<template>
  <b-overlay :show="loadingProfiles">
    <div>
      <b-card>
        <div class="row justify-content-between">
          <div class="col-6">
            <h4 class="text-primary mb-10">
              Gestión de perfiles de acceso para usuarios
            </h4>
          </div>
          <div class="col-6 text-right">
            <button
              class="btn btn-primary"
              v-tooltip="'Agregar perfil'"
              @click="addProfile()"
              data-cy="add-profile"
              v-has-permission="'WAP100'"
            >
              <feather-icon icon="PlusIcon" />
            </button>
            <button
              class="ml-2 btn btn-secondary"
              v-tooltip="'Descargar'"
              @click="reportProfile(true)"
              data-cy="download-profiles"
              v-has-permission="'WAP107'"
            >
              <feather-icon icon="DownloadIcon" />
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ul class="list-group mt-5">
              <li
                :key="'profile-'+ profile.idPerfil"
                :id="'profile-'+ profile.idPerfil"
                v-for="profile in companyProfiles"
                class="list-group-item"
              >
                <div class="actions cursor-pointer">
                  <feather-icon
                    class="icon mr-2"
                    size="18"
                    icon="ListIcon"
                    v-tooltip="'Bitácora'"
                    v-on:click="getBinnacleProfile(profile)"
                    data-cy="binnacle"
                    v-has-permission="'WAP105'"
                  />
                  <feather-icon
                    class="icon mr-2"
                    size="18"
                    icon="SendIcon"
                    v-tooltip="`Migrar perfil a otro ambiente desde ${environment}`"
                    v-on:click="migrateProfile(profile)"
                    data-cy="migrate-profile"
                    v-has-permission="'WAP104'"
                  />
                  <feather-icon
                    class="icon mr-2"
                    size="18"
                    icon="UsersIcon"
                    v-tooltip="'Usuarios asociados a perfil'"
                    v-on:click="getUsersProfile(profile)"
                    data-cy="get-users-profile"
                    v-has-permission="'WAP106'"
                  />
                  <feather-icon
                    class="icon mr-2"
                    size="18"
                    icon="EditIcon"
                    color="green"
                    v-tooltip="'Modificar perfil'"
                    v-on:click="editProfileInfo(profile)"
                    data-cy="edit-profile-info"
                    v-has-permission="'WAP101'"
                  />
                  <feather-icon
                    class="icon mr-2"
                    size="18"
                    icon="KeyIcon"
                    v-tooltip="'Agregar roles'"
                    v-on:click="getProfileInfo(profile)"
                    data-cy="get-profile-info"
                    v-has-permission="'WAP103'"
                  />
                  <feather-icon
                    class="icon"
                    size="18"
                    icon="TrashIcon"
                    color="red"
                    v-tooltip="'Eliminar perfil'"
                    v-on:click="removeProfile(profile)"
                    data-cy="delete-profile"
                    v-has-permission="'WAP102'"
                  />
                </div>
                <div class="row">
                  <div class="col-md-8 col-12">
                    <b>Nombre: </b> {{ profile.nombre}}
                  </div>
                  <div class="col-md-8 col-12 mt-2">
                    <div class="about pr-3">
                      <b>Descripción: </b> {{ profile.descripcion }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </b-card>
    </div>
    <b-modal
      size="xl"
      ref="profileRoles"
      hide-footer
      no-close-on-backdrop
      :title="`Roles del perfil ${profile.nombre}`"
    >
      <b-overlay :show="loadingRoles">
        <div class="d-flex align-items-center justify-content-end">
          <b-form-input
            v-model="searchInVacantRoles"
            class="d-inline-block mr-1"
            placeholder="Filtrar..."
            data-cy="search-vacant-role"
          />
        </div>
        <div class="row mt-3 px-2">
          <div
            class="col-6"
            style="height: 500px;overflow: scroll;"
          >
            <div
              class="row mt-2 mb-2"
              v-for="role in Object.values(filteredAvailableRoles)"
              :key="role.id"
            >
              <div class="col-8 profile p-4">
                <div class="name">{{ role.nombre }}</div>
              </div>
              <div class="col-4 text-left mt-4">
                <b-button
                  size="sm"
                  variant="success"
                  class="mr-1"
                  v-on:click.once="addRoleToProfile(role)"
                  v-if="!profileRoles[role.id]"
                >
                  agregar
                </b-button>
              </div>
            </div>
          </div>
          <div
            class="col-6"
            style="height: 500px;overflow: scroll;"
          >
            <div
              class="row mt-2 mb-2"
              v-for="role in Object.values(profileRoles)"
              :key="role.rolId"
            >
              <div class="col-8 profile p-4">
                <div class="name">{{ role.nombre }}</div>
              </div>
              <div class="col-4 text-left mt-4">
                <b-button
                  size="sm"
                  variant="warning"
                  class="mr-1"
                  v-on:click.once="removeRoleToProfile(role)"
                >
                  remover
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </b-modal>
    <b-modal
      size="md"
      ref="addProfile"
      hide-footer
      no-close-on-backdrop
      :title="`Perfil de acceso`"
    >
      <div class="row mt-3">
        <form
          data-vv-scope="profile"
          class="w-100"
        >
          <div class="col-12">
            <b-form-group
              label="Nombre del perfil"
            >
              <b-form-input
                name="name"
                class="w-100"
                data-vv-as="Nombre del perfil"
                v-model="newProfile.name"
                v-validate="'required|max:255'"
                :state="!errors.has('profile.name') && newProfile.name !== ''"
              />
              <FormError
                attributeName="profile.name"
                :errorsForm="errors"
              />
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group
              label="Descripción del perfil"
            >
              <b-form-input
                label="Descripción del perfil"
                name="description"
                class="w-100"
                data-vv-as="Descripción del perfil"
                v-model="newProfile.description"
                v-validate="'required|max:255'"
                :state="!errors.has('profile.description') && newProfile.description !== ''"
              />
              <FormError
                attributeName="profile.description"
                :errorsForm="errors"
              />
            </b-form-group>
          </div>
        </form>
      </div>
      <div class="text-center">
        <b-button
          v-if="!editMood"
          variant="primary"
          v-on:click.once="addNewProfile()"
          class="mr-1"
          :disabled="loadingProfiles"
        >
          Agregar
        </b-button>
        <b-button
          v-if="editMood"
          variant="primary"
          v-on:click.once="editProfile()"
          class="mr-1"
          :disabled="loadingProfiles"
          data-cy="update-profile"
        >
          Editar
        </b-button>
      </div>
    </b-modal>
    <b-modal
      ref="migrate-profile-modal"
      hide-footer
      no-close-on-backdrop
      :title="`Migrar perfil ${profile.nombre}`"
    >
      <b-overlay :show="isMigratingProfile">
        <v-select
          v-model="targetEnvironment"
          multiple
          label="title"
          :options="avalaibleEnvironments"
        />
        <div class="text-center mt-3">
          <b-button
            variant="primary"
            v-on:click.once="migrateProfileToTargetEnvironments()"
            class="mr-1"
          >
            Migrar
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
    <b-modal
      ref="profileUsers"
      hide-footer
      no-close-on-backdrop
      size="lg"
      :title="`Usuarios asociados a perfil ${profile.nombre}`"
    >
      <b-overlay :show="loadingRoles">
        <div class="text-center my-1" v-if="!usersProfile.length">
          No se encontraron usuarios asociados a este perfil
        </div>
        <div
          class="wrap-table"
          v-if="!!usersProfile.length"
          style="width:100%; height:300px; overflow : hidden; overflow-y : scroll"
        >
          <table class="table-users stripe" aria-description="table-users">
            <th>Nombre</th>
            <th>Correo</th>
            <tr :key="indextr" v-for="(user, indextr) in usersProfile" data-cy="users-profile">
              <td
                v-b-tooltip="user.nombre"
                class="text-truncate"
              >
                  <span class="d-flex">
                    <img
                      key="onlineImg"
                      :src="userAvatar(user.avatar)"
                      alt="user-img"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md cursor-pointer"
                    />
                    <span class="ml-3" style="line-height: 40px;">
                      {{ user.nombre }}
                    </span>
                  </span>
              </td>
              <td
                v-b-tooltip="user.correo"
                class="text-truncate"
              >
                {{ user.correo }}
              </td>
            </tr>
          </table>
        </div>
      </b-overlay>
    </b-modal>
    <b-modal
      ref="binnacleProfile"
      size="lg"
      hide-footer
      :title="`Bitácora del perfil ${profile.nombre}`"
    >
      <binnacle-user
        :user="profile"
        :binnacle-user="binnacleProfile"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      ref="modalReport"
      title="Descargar reporte de perfiles"
      hide-footer
      @hidden="resetModalReport"
    >
      <b-overlay :show="loadingParamsProfile">
        <strong>Seleccione los parámetros para el reporte</strong>
        <div class="mt-4 row justify-content-between">
          <div
            class="col-6"
            :key="option.key"
            v-for="(option) in optionsReportProfile"
          >
            <b-form-group
              :label="`Categoría ${option.nombre}`"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                v-model="selectedParams"
                :options="option.campos"
                :aria-describedby="ariaDescribedby"
                switches
                stacked
                value-field="key"
                text-field="nombre"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </div>
        <div class="text-right">
          <b-button
            variant="primary"
            @click="reportProfile(false)"
          >
            Enviar
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import FormError from '@/febos/global/documentManagement/components/FormError';
import BinnacleUser from '@/febos/global/management/vistas/components/BinnacleUser';
import { getCompanyRoles } from '@/febos/servicios/api/empresas.api';
import {
  ioAddRoleToAccessProfile,
  ioGetRolesAccessProfiles,
  ioRemoveRoleToAccessProfile,
  ioAddAccessProfile,
  ioEditAccessProfile,
  ioRemoveProfile,
  ioMigrateProfile,
  ioGetUsersProfile,
  ioProfileReport
} from '@/febos/servicios/api/v2.companies.api';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';

const environments = [
  { title: 'Desarrollo', value: 'desarrollo' },
  { title: 'Pruebas', value: 'pruebas' },
  { title: 'Certificación', value: 'certificacion' },
  { title: 'Produccion', value: 'produccion' }
];

export default {
  name: 'AccessProfile',
  data() {
    return {
      isMigratingProfile: false,
      targetEnvironment: [],
      profileRoles: [],
      profile: {},
      newProfile: {
        name: '',
        description: ''
      },
      editMood: true,
      perfilId: '',
      loading: false,
      loadingRoles: false,
      loadingProfiles: false,
      searchInVacantRoles: '',
      rolesList: {},
      usersProfile: [],
      noAvatar: require('../../../../assets/images/no-avatar.svg'),
      binnacleProfile: [],
      optionsReportProfile: [],
      selectedParams: [],
      loadingParamsProfile: false
    };
  },
  components: {
    FormError,
    BinnacleUser
  },
  computed: {
    ...mapGetters('Management', [
      'companyProfiles'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    environment() {
      return process.env.VUE_APP_AMBIENTE;
    },
    avalaibleEnvironments() {
      return environments.filter(
        (environment) => environment.value !== this.environment
      );
    },
    filteredAvailableRoles() {
      if (this.searchInVacantRoles !== '') {
        return Object.values(this.rolesList).filter(
          (rol) => rol.nombre.toLowerCase().indexOf(this.searchInVacantRoles.toLowerCase()) > -1
        );
      }
      return this.rolesList;
    }
  },
  watch: {
    profile() {
      this.profileRoles = [];
      this.editMood = false;
    }
  },
  methods: {
    ...mapActions('Management', [
      'getCompanyAccessProfiles'
    ]),
    ...mapActions('Empresas', [
      'getBinnacle'
    ]),
    async loadRolesList() {
      this.loading = true;
      const response = await getCompanyRoles({
        empresaId: this.company.id,
        params: {
          filas: 10000,
          pagina: 1
        }
      });
      this.rolesList = response.data.roles.reduce((accumulator, role) => ({
        ...accumulator,
        [role.id]: { ...role }
      }), {});
      this.loading = false;
    },
    async closeModal() {
      this.loading = true;
      if (this.$refs.profileRoles) {
        this.$refs.profileRoles.hide();
      }
      this.loading = false;
    },
    editProfileInfo(profile) {
      this.editMood = true;
      this.perfilId = '';
      this.newProfile = {
        name: profile.nombre,
        description: profile.descripcion
      };
      this.perfilId = profile.idPerfil;
      this.$refs.addProfile.show();
    },
    async removeProfileAccess() {
      try {
        await ioRemoveProfile({
          empresaId: this.company.id,
          perfilId: this.perfilId
        });
        this.perfilId = '';
        this.loadingProfiles = true;
        this.$bvToast.toast(
          'Se ha removido el perfil',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
        this.loadingProfiles = false;
        await this.getCompanyAccessProfiles({ empresaId: this.company.id });
      } finally {
        this.loadingProfiles = false;
      }
    },
    removeProfile(profile) {
      this.perfilId = profile.idPerfil;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Heey!',
        text: '¿Estás seguro de remover este perfil, esto removerá los roles asociados a los usuarios?',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.removeProfileAccess(),
        cancel: () => {
        }
      });
    },
    migrateProfile(profile) {
      this.perfilId = profile.idPerfil;
      this.profile = profile;
      this.$refs['migrate-profile-modal'].show();
    },
    async migrateProfileToTargetEnvironments() {
      if (this.targetEnvironment.length === 0 || !this.targetEnvironment) {
        return;
      }
      this.isMigratingProfile = true;
      try {
        const targetEnvironments = this.targetEnvironment.map((environment) => environment.value);
        await ioMigrateProfile({
          companyId: this.company.id,
          profileId: this.perfilId,
          environments: targetEnvironments
        });
        this.$refs['migrate-profile-modal'].hide();
        this.isMigratingProfile = false;
      } catch (error) {
        console.error(error);
        this.isMigratingProfile = false;
      }
    },
    async getUsersProfile(profile) {
      this.usersProfile = [];
      this.loadingProfiles = true;
      this.perfilId = profile.idPerfil;
      this.profile = profile;

      try {
        const response = await ioGetUsersProfile({
          empresaId: this.company.id,
          perfilId: profile.idPerfil
        });
        this.usersProfile = response.data.usuarios;
        this.$refs.profileUsers.show();
      } finally {
        this.loadingProfiles = false;
      }
    },
    async getProfileInfo(profile) {
      this.profileRoles = [];
      this.loadingProfiles = true;
      await this.loadRolesList();
      this.profile = profile;
      this.$refs.profileRoles.show();
      const response = await ioGetRolesAccessProfiles({
        empresaId: this.company.id,
        perfilId: profile.idPerfil
      });
      this.profileRoles = response.data.roles.reduce((accumulator, role) => ({
        ...accumulator,
        [role.rolId]: { ...role }
      }), {});
      this.loadingProfiles = false;
    },
    async addRoleToProfile(role) {
      this.loadingRoles = true;
      try {
        await ioAddRoleToAccessProfile({
          empresaId: this.company.id,
          perfilId: this.profile.idPerfil,
          rolId: role.id
        });
        this.loadingRoles = false;
        this.$bvToast.toast(
          'Se ha agregado el rol exitosamente',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
        const response = await ioGetRolesAccessProfiles({
          empresaId: this.company.id,
          perfilId: this.profile.idPerfil
        });
        this.profileRoles = response.data.roles.reduce((accumulator, roleMap) => ({
          ...accumulator,
          [roleMap.rolId]: { ...roleMap }
        }), {});
        this.loadingRoles = false;
      } finally {
        this.loadingRoles = false;
      }
    },
    async removeRoleToProfile(role) {
      this.loadingRoles = true;
      try {
        await ioRemoveRoleToAccessProfile({
          empresaId: this.company.id,
          perfilId: this.profile.idPerfil,
          rolId: role.rolId
        });
        this.loadingRoles = false;
        this.$bvToast.toast(
          'Se ha removido el rol exitosamente',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
        const response = await ioGetRolesAccessProfiles({
          empresaId: this.company.id,
          perfilId: this.profile.idPerfil
        });
        this.profileRoles = response.data.roles.reduce((accumulator, roleMap) => ({
          ...accumulator,
          [roleMap.rolId]: { ...roleMap }
        }), {});
        this.loadingRoles = false;
      } finally {
        this.loadingRoles = false;
      }
    },
    async reportProfile(simulate) {
      try {
        this.$refs.modalReport.show();
        if (!simulate && !this.selectedParams.length) {
          this.$vs.notify({
            title: 'Error',
            text: 'Por favor, ingresa algún parámetro para el reporte',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: ALERT_POSITION
          });
          return;
        }
        this.loadingParamsProfile = true;
        const { data } = await ioProfileReport({
          empresaId: this.company.id,
          simular: simulate ? 'si' : 'no',
          body: {
            ...((!simulate && !!this.selectedParams.length) && { campos: this.selectedParams })
          }
        });

        if (simulate) {
          this.optionsReportProfile = data.esquema;
        } else {
          this.$bvToast.toast(
            'Se está descargando su archivo',
            {
              title: '¡Danos unos segundos!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 1500
            }
          );
          window.open(data.url, '_blank');
          this.$refs.modalReport.hide();
          this.$bvToast.toast(
            'El archivo se ha descargado exitosamente',
            {
              title: '¡Éxito!',
              variant: 'success',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 3000
            }
          );
        }
      } finally {
        this.loadingParamsProfile = false;
      }
    },
    resetModalReport() {
      this.selectedParams = [];
      this.optionsReportProfile = [];
    },
    addProfile() {
      this.editMood = false;
      this.newProfile = {
        name: '',
        description: ''
      };
      this.$refs.addProfile.show();
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addNewProfile() {
      this.loadingProfiles = true;
      const isValid = await this.validateForm('profile');
      if (!isValid) {
        this.loadingProfiles = false;
        return;
      }
      try {
        await ioAddAccessProfile({
          empresaId: this.company.id,
          nombre: this.newProfile.name,
          descripcion: this.newProfile.description,
          params: {
            global: 'no'
          }
        });
        this.$refs.addProfile.hide();
        this.$bvToast.toast(
          'Se ha creado el perfil',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
        this.loadingProfiles = false;
        await this.getCompanyAccessProfiles({ empresaId: this.company.id });
      } finally {
        this.loadingProfiles = false;
      }
    },
    async editProfile() {
      this.loadingProfiles = true;
      const isValid = await this.validateForm('profile');
      if (!isValid) {
        this.loadingProfiles = false;
        return;
      }
      try {
        await ioEditAccessProfile({
          empresaId: this.company.id,
          perfilId: this.perfilId,
          nombre: this.newProfile.name,
          descripcion: this.newProfile.description,
          params: {
            global: 'no'
          }
        });
        this.$refs.addProfile.hide();
        this.editMood = false;
        this.perfilId = '';
        this.$bvToast.toast(
          'Se ha actualizado el perfil',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
        this.loadingProfiles = false;
        await this.getCompanyAccessProfiles({ empresaId: this.company.id });
      } finally {
        this.loadingProfiles = false;
      }
    },
    userAvatar(avatar) {
      return avatar || this.noAvatar;
    },
    async getBinnacleProfile(profile) {
      this.loadingProfiles = true;
      this.binnacleProfile = await this.getBinnacle(profile.idPerfil);
      this.profile = { ...profile };
      this.$refs.binnacleProfile.show();
      this.loadingProfiles = false;
    }
  },
  async mounted() {
    this.loadingProfiles = true;
    await this.getCompanyAccessProfiles({ empresaId: this.company.id });
    this.loadingProfiles = false;
    this.editMood = false;
    this.perfilId = '';
  },
  created() {
    this.editMood = false;
    this.perfilId = '';
    this.loadingProfiles = false;
  }
};
</script>
<style
  lang="css"
  scoped
>
.profile {
  background: white;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border-radius: 5px;
  padding: 10px;
}

.name {
  color: black !important;
}

.user-info {
  display: inline-block;
  padding-left: 15px;
  vertical-align: middle;
}

.is-selected {
  color: red;
}

.download {
  top: 100px;
  right: 40px;
}

.wrap-actions {
  display: flex;
  justify-content: space-around;
}
.table-users {
  width: 100%;
}

tr:nth-child(even) {
  background-color: #f0f0f0;
}
.wrap-table {
  overflow-y: auto;
}
.group-element {
  margin-top: 4px;
}

</style>

<style scoped>
.actions {
  position: relative;
  float: right;
}

.icon {
  margin-right: 5px;
}
</style>
